module.exports = "https://dashboard.cdn.gifty.nl/6217/images/mailbox-white.png?e6f3f0852ddf5976b5b1797ee981d08c";